import { OG_IMAGE_SLUGS } from '@/data/ogImageSlugs';

const DEFAULT_OG_IMAGE = '/social/og-1200x630.png';

/**
 * Returns the per-app OG image path if we have a generated image for the slug,
 * otherwise the default social OG image.
 */
export function getAppOgImage(slug: string | undefined): string {
  if (!slug) return DEFAULT_OG_IMAGE;
  return OG_IMAGE_SLUGS.has(slug) ? `/og/${slug}.png` : DEFAULT_OG_IMAGE;
}
